
// frontend/geopolitikia/src/components/MobileStat.jsx
import React, { useState } from 'react';
import StatMobile from "./StatistiquesMobile.jsx";
import EcoEnergyStats from "./EcoEnergyStatsMobile.jsx";

const MobileStat = ({ gameState, mobile }) => {
  const [activeStatView, setActiveStatView] = useState('general'); // 'general' or 'eco_energy'

  return (
    <div className="h-full overflow-scroll custom-scrollbar bg-slate-900 flex flex-col">
      <div className="flex-1 ">
        {activeStatView === 'general' && (
          <StatMobile
            gameState={gameState} mobile={mobile} setActiveStatView={setActiveStatView}
          />
        )}
        {activeStatView === 'eco_energy' && (
          <EcoEnergyStats
            gameState={gameState} mobile={mobile} setActiveStatView={setActiveStatView}
          />
        )}
      </div>
    </div>
  );
};

export default MobileStat;
